import { initialize } from "pinpo-model-kit"

initialize({
	appId: process.env.REACT_APP_PARSE_APP_ID,
	javascriptKey: process.env.REACT_APP_PARSE_JAVASCRIPT_KEY,
	serverURL: process.env.REACT_APP_PARSE_SERVER_URL,
	liveQueryServerUrl: process.env.REACT_APP_PARSE_LIVE_QUERY_SERVER
})
